export const LISTINGS = {
         en: [
           {
             id: 'free-messaging',
             label: 'Free messaging',
           },
           {
             id: 'calendar-booking-daily',
             label: 'Calendar booking daily',
           },
           {
             id: 'Accommodation',
             label: 'Experience & accommodation',
           },
           {
             id: 'calendar-bookig-hourly',
             label: 'Calendar booking hourly',
           },
           {
             id: 'fixed-booking-length',
             label: 'Fixed booking length',
           },
           {
             id: 'promotional_ID',
             label: 'Promotional item ',
           },
         ],

         hr: [
           {
             id: 'free-messaging',
             label: 'Usluge na upit',
           },
           {
             id: 'calendar-booking-daily',
             label: 'Bukiranje usluga na dnevnoj bazi',
           },
           {
             id: 'Accommodation',
             label: 'Experience & smještaj',
           },
           {
             id: 'calendar-bookig-hourly',
             label: 'Bukiranje usluga po satu',
           },
           {
             id: 'fixed-booking-length',
             label: 'Usluge sa fiksnim trajanjem',
           },
           {
             id: 'promotional_ID',
             label: 'Promotivni sadržaj ',
           },
         ],
       };

export const LISTINGS_FIELDS = {
         en: [
           {
             id: 'Culture',
             label: 'Culture',
           },
           {
             id: 'gastronomy',
             label: 'Gastronomy',
           },
           {
             id: 'retreat-holism',
             label: 'Retreat & holism',
           },
           {
             id: 'sportadrenalin',
             label: 'Sport & adrenalin',
           },
           {
             id: 'Fishing',
             label: 'Fishing',
           },
           {
             id: 'Luxuryexperiences',
             label: 'Luxury experiences',
           },
           {
             id: 'Accomodation',
             label: 'Experience & accommodation',
           },
           {
             id: 'Enology',
             label: 'Enology',
           },
           {
             id: 'Medicaltourisim',
             label: 'Health tourisim',
           },
           {
             id: 'Museums_Galleries_id',
             label: 'Museums and Galleries',
           },
           {
             id: 'Free_tours_id',
             label: 'Free tours',
           },
         ],

         hr: [
           {
             id: 'Culture',
             label: 'Kultura',
           },
           {
             id: 'gastronomy',
             label: 'Gastro',
           },
           {
             id: 'retreat-holism',
             label: 'Retreat & holizam',
           },
           {
             id: 'sportadrenalin',
             label: 'Sport & adrenalin',
           },
           {
             id: 'Fishing',
             label: 'Ribolov',
           },
           {
             id: 'Luxuryexperiences',
             label: 'Luksuzna iskustva',
           },
           {
             id: 'Accomodation',
             label: 'Experience & smještaj',
           },
           {
             id: 'Enology',
             label: 'Enologija',
           },
           {
             id: 'Medicaltourisim',
             label: 'Medicinski turizam',
           },
           {
             id: 'Museums_Galleries_id',
             label: 'Muzeji i Galerije',
           },
           {
             id: 'Free_tours_id',
             label: 'Besplatne ture',
           },
         ],
       };
